class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class PromoStatuses extends HTMLElement {
  constructor() {
    super();
    this.promos = []
  }

  connectedCallback() {
    this.renderPromos();
  }

  setPromos(promos = []) {
    this.promos = [...promos];
    this.renderPromos();
  }

  renderPromos() {
    const promos = new DocumentFragment;

    this.promos.forEach((promoData) => {
      const promo = document.getElementById(`promoStatus`).content.cloneNode(true);

      promoData.statuses.forEach((promoStatus) => {
        promo.firstElementChild.classList.add(`promo-status--${promoStatus}`);
      });

      promo.firstElementChild.style.setProperty(`--threshold-percentage`, promoData.theshold_percentage);

      if (!promoData.button_cta) {
        promo.querySelector(`a`).remove();
      }

      const updated_promo = modifyHTML(promo, (html_string) => {
        html_string = html_string.split(`[[ heading ]]`).join(promoData.heading);
        html_string = html_string.split(`[[ initial_message ]]`).join(promoData.initial_message);
        html_string = html_string.split(`[[ in_progress_message ]]`).join(promoData.in_progress_message);
        html_string = html_string.split(`[[ completed_message ]]`).join(promoData.completed_message);

        if (promoData.button_cta) {
          html_string = html_string.split(`[[ button_url ]]`).join(promoData.button_url);
          html_string = html_string.split(`[[ button_cta ]]`).join(promoData.button_cta);
        }

        return html_string;
      });

      promos.appendChild(updated_promo);
    })

    this.innerHTML = ``;
    this.appendChild(promos);
  }
}

customElements.define(`promo-statuses`, PromoStatuses);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.isInvalid = window.gopuffShopify.cart.checkout_disabled;
    this.isCartLoading = false;
    this.isValidating = true;
    this.liveRegionCounter = 0;
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.header = document.querySelector('sticky-header');
    this.alertsStatusElement = document.getElementById('cart-alerts') || document.getElementById('CartDrawer-CartAlerts');
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    this.form = document.getElementById('cart') || document.getElementById('CartDrawer-Form');
    this.cartChangesElement = document.getElementById('shopping-cart-changes') || document.getElementById('CartDrawer-CartChanges');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.renderPromoStatuses();
    this.checkProductAvailability();
    this.addEventListener('change', debouncedOnChange.bind(this));
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  cartUpdateUnsubscriber = undefined;
  locationUpdateUnsubscriber = undefined;

  async getCartJSON(refresh) {
    if (!refresh && window.cart) { return window.cart; }
  
    const cart = await fetch(`/cart.json`).then((response) => response.json());
    window.cart = cart;
  
    return cart;
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
      if (event.source === 'cart-items') { return; }
      
      await this.getCartJSON(true);
      this.onCartUpdate(event);
    });

    this.locationUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.deliveryLocationUpdate, this.checkProductAvailability.bind(this));
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    if (this.locationUpdateUnsubscriber) {
      this.locationUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate(event) {
    if (event.cart) {
      this.classList.toggle('is-empty', event.cart.item_count === 0);
    }

    fetch('/cart?section_id=main-cart-items')
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
        this.checkProductAvailability();
      })
      .catch(e => {
        console.error(e);
      });
  }

  updateFocusableElements() {
    reTrapFocus();
  }

  checkCheckoutDisabled() {
    const disable = Boolean(this.isCartLoading || this.isValidating || this.isInvalid);
    const showLoader = this.isValidating || this.isCartLoading;
    const disabledMessage = window.gopuffShopify.cart.checkout_disabled_message || ``;
    const checkoutButton = document.querySelector(`button[type="submit"][form="${this.form.id}"`);
    window.gopuffShopify.cart.checkout_disabled = disable;
    
    this.cart.classList.toggle(`loading`, showLoader);

    if (checkoutButton) {
      checkoutButton.classList.toggle(`loading`, showLoader);

      if (disable) {
        checkoutButton.setAttribute('disabled', '');
      } else {
        checkoutButton.removeAttribute('disabled');
      }
    }

    document.querySelectorAll('[data-checkout-disabled-message]').forEach((checkoutTextEl) => {
      checkoutTextEl.innerHTML = this.isInvalid && !showLoader
        ? disabledMessage
        : ``;
    });

    const additionalCheckoutButtons = document.querySelector('.additional-checkout-buttons');

    if (additionalCheckoutButtons) {
      additionalCheckoutButtons.classList.toggle('hidden', disable);
    }

    if (document.querySelector(`cart-drawer`) && document.querySelector(`cart-drawer`).isOpen) {
      this.updateFocusableElements();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  async updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    this.setCartLoading(true);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    try {
      const response = await fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      const state = await response.text();
      const parsedState = JSON.parse(state);

      gopuffCustomAnalytics.mapAndPublishShopifyCartResponseToCustomAnalyticsEvents(parsedState);
      const cartData = parsedState.token ? parsedState : null;

      if (cartData) {
        window.cart = cartData;
      }

      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      const items = document.querySelectorAll('.cart-item');
  
      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute('value');
        this.updateLiveRegions(line, parsedState.errors);
        this.disableLoading(line);
        this.setCartLoading(false);

        return;
      }
  
      this.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');
  
      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
  
      this.getSectionsToRender().forEach((section => {
        const elementToReplace = 
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = 
          this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
      // this.checkCheckoutDisabled();
      
      const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
      let message = '';
      if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
        if (typeof updatedValue === 'undefined') {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
        }
      }
      this.updateLiveRegions(line, message);
  
      const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);

      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'))
      } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
      }
      
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cart: parsedState });
      this.disableLoading(line);
    } catch(e) {
      console.error(e);
      this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
      this.renderAlerts(this.alertsStatusElement, [{ error_code: `shopify`, message: window.cartStrings.error }], `cart`);
      this.disableLoading(line);
      this.setCartLoading(false);
    }
  }

  activateLiveRegion() {
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
    this.liveRegionCounter++;
    const currentCount = this.liveRegionCounter;

    setTimeout(() => {
      if (this.liveRegionCounter !== currentCount) { return; }

      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  updateLiveRegions(line, message) {
    if (!message) { return; }

    const lineItemAlert = document.getElementById(`Line-item-alert-${line}`) || document.getElementById(`CartDrawer-LineItemAlert-${line}`);
    this.renderAlerts(lineItemAlert, [{ error_code: `shopify`, message: message }]);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  getItemGiveaway(item = {}) {
    const giveaways = window.gopuffShopify.settings.giveaways || [];
    const itemGiveaway = giveaways.filter((giveaway) => {
      return giveaway.skus.indexOf(item.sku) > -1;
    })[0];  

    return itemGiveaway;
  }

  getCartGiveaway(cart = window.cart) {
    const items = cart.items || [];

    for (const item of items) {
      const giveaway = this.getItemGiveaway(item);

      if (giveaway) {
        return giveaway;
      }
    }
  }

  prepareFormFields(useSubmit) {
    const fieldsFragment = new DocumentFragment;
    const deliveryLocation = JSON.parse(window.localStorage.getItem("delivery_location"));
    const giveaway = this.getCartGiveaway();
    const fields = [
      {
        name: `attributes[address]`,
        value: JSON.stringify(deliveryLocation.address),
      },
      {
        name: `attributes[fulfillment_display_name]`,
        value: deliveryLocation.fulfillment_display_name,
      },
      {
        name: `attributes[location_id]`,
        value: deliveryLocation.location_id,
      },
      {
        name: `attributes[cart_token]`,
        value: Cookies.get(`cart`).split('?')[0],
      }
    ];

    if (useSubmit) {
      fields.push({ 
        name: `checkout`, 
        value: ``
      });
    }

    if (giveaway) {
      fields.push({
        name: `discount`,
        value: giveaway.discount_code,
      });
    }

    const ageVerification = document.querySelector(`location-modal`).getAgeVerification();

    if (ageVerification) {
      fields.push({
        name: `attributes[email]`,
        value: ageVerification.email,
      },
      {
        name: `attributes[phone]`,
        value: ageVerification.phone,
      });

      if (window.gopuffShopify.settings.age_verification.cookie_keys_for_attributes) {
        const additionalFieldKeys = window.gopuffShopify.settings.age_verification.cookie_keys_for_attributes.split(`, `).join(`,`).split(`,`);
        additionalFieldKeys.forEach((additionalKey) => {
          if (ageVerification[additionalKey] === undefined) { return; }

          fields.push({
            name: `attributes[${additionalKey}]`,
            value: JSON.stringify(ageVerification[additionalKey]),
          })
        });
      }
    }

    fields.forEach(({ name, value }) => {
      const field = document.createElement('input');

      field.setAttribute('type', 'hidden');
      field.setAttribute('name', name);
      field.setAttribute('value', value);

      fieldsFragment.appendChild(field);
    });

    this.form.appendChild(fieldsFragment);
  }

  async setAttributesForSubmit(formData) {
    try {
      await fetch(`${routes.cart_update_url}`, {
        method: 'POST',
        ...{ body: new URLSearchParams(formData) }
      });
    } catch (error) {
      console.log(`error setting attributes for submit`, error);
    }
  }

  async onSubmit(evt) {
    evt.preventDefault();
    const deliveryLocation = JSON.parse(window.localStorage.getItem("delivery_location"));

    if (!deliveryLocation || !deliveryLocation.address || !deliveryLocation.location_id) {
      return;
    };

    const proceedToCheckout = await this.checkProductAvailability(null, true);

    if (!proceedToCheckout) {
      return;
    }

    const nonGiveawayItems = window.cart.items.filter((item) => {
      return !this.getItemGiveaway(item);
    });

    const isSSORequired = Boolean(!window.gopuffShopify.customer && window.gopuffShopify.settings.gopuff_sign_in_url && (nonGiveawayItems.length === 0));
    const useSubmit = !isSSORequired;
    this.prepareFormFields(useSubmit);
    const formData = new FormData(this.form);
    await this.setAttributesForSubmit(formData);

    if (useSubmit) {
      document.querySelector(`location-modal`).setCheckoutAddress(deliveryLocation.address)
        .finally(() => {
          this.form.submit();
        });

      return;
    }

    const addressParams = {
      'address1': 'checkout[shipping_address][address1]',
      'unit': 'checkout[shipping_address][address2]',
      'city': 'checkout[shipping_address][city]',
      'province': 'checkout[shipping_address][province]',
      'postalCode': 'checkout[shipping_address][zip]',
      'country': 'checkout[shipping_address][country]',
    }

    for (var key in addressParams) {
      formData.append(addressParams[key], deliveryLocation.address[key]);
    }

    const params = new URLSearchParams(formData).toString();
    const redirectURL = `/checkout?${params}`;

    window.location = `${window.gopuffShopify.settings.gopuff_sign_in_url}?shop=${Shopify.shop}&redirect_url=${encodeURIComponent(redirectURL)}`;
  }

  async limitQuantity(cartItem, availableQuantity) {
    const quantityInput = cartItem.querySelector('quantity-input');
    let cartChangeMessage = '';
    let itemChangeMessage = '';
            
    if (availableQuantity !== undefined) {
      quantityInput.setMax(availableQuantity);
      quantityInput.validateQtyRules();

      if (Number(quantityInput.input.value) > availableQuantity) {
        await this.updateQuantity(quantityInput.input.dataset.index, availableQuantity, '');

        if (availableQuantity == 0) {
          const title = cartItem.querySelector('.cart-item__name').textContent;
          cartChangeMessage = gopuffShopify.strings.unavailable_removed_from_cart.replace('{{ title }}', title);
        } else {
          itemChangeMessage = window.cartStrings.quantityError.replace('[quantity]', availableQuantity);
        }
      }
    }

    if (itemChangeMessage) {
      const lineItemErrorText = cartItem.querySelector('.cart-item__error-text');

      if (lineItemErrorText) {
        lineItemErrorText.textContent = itemChangeMessage;
      }
    }

    return cartChangeMessage;
  }

  mapShopifyErrors(shopifyErrors = []) {
    return shopifyErrors.map((error) => {
      return {
        error_code: `shopify`,
        message: error.description,
        level: `error`,
      }
    });
  }

  mapCartErrors(cartErrors = []) {
    return cartErrors.map((error) => {
      return {
        error_code: error.type,
        message: error.message,
        level: `error`
      }
    });
  }

  mapCartInfo(cartInfo = []) {
    return cartInfo.map((info) => {
      return {
        ...info,
        level: `info`,
      };
    })
  }

  getErrorIcon() {
    return `
      <svg 
        class="icon icon-error"   
        aria-hidden="true"
        focusable="false"
        xmlns="http://www.w3.org/2000/svg" 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none"
      >
        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
        <path d="M12 7.5V12.75" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
        <path d="M12 17.25C12.6213 17.25 13.125 16.7463 13.125 16.125C13.125 15.5037 12.6213 15 12 15C11.3787 15 10.875 15.5037 10.875 16.125C10.875 16.7463 11.3787 17.25 12 17.25Z" fill="currentColor"/>
      </svg>`;
  }

  getInfoIcon() {
    return this.getErrorIcon();
    // return `
    //   <svg 
    //     class="icon icon-info"   
    //     aria-hidden="true"
    //     focusable="false"
    //     xmlns="http://www.w3.org/2000/svg" 
    //     width="24" 
    //     height="24" 
    //     viewBox="0 0 24 24" 
    //     fill="none"
    //   >
    //     <path d="M12 9.75V13.5" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
    //     <path d="M10.7015 3.74857L2.45374 17.9978C2.32177 18.2258 2.25217 18.4846 2.25195 18.748C2.25174 19.0115 2.32091 19.2703 2.4525 19.4986C2.5841 19.7268 2.77348 19.9163 3.0016 20.0481C3.22971 20.1799 3.48851 20.2493 3.75196 20.2493H20.2475C20.5109 20.2493 20.7697 20.1799 20.9979 20.0481C21.226 19.9163 21.4154 19.7268 21.547 19.4986C21.6786 19.2703 21.7477 19.0115 21.7475 18.748C21.7473 18.4846 21.6777 18.2258 21.5457 17.9978L13.2979 3.74857C13.1662 3.52093 12.9769 3.33193 12.749 3.20055C12.5212 3.06916 12.2628 3 11.9997 3C11.7367 3 11.4783 3.06916 11.2504 3.20055C11.0226 3.33193 10.8333 3.52093 10.7015 3.74857V3.74857Z" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
    //     <path d="M12 18C12.6213 18 13.125 17.4963 13.125 16.875C13.125 16.2537 12.6213 15.75 12 15.75C11.3787 15.75 10.875 16.2537 10.875 16.875C10.875 17.4963 11.3787 18 12 18Z" fill="currentColor"/>
    //   </svg>`;
  }

  renderAlerts(alertsContainer, alerts = [], alert_basis = `cart-item`) {
    const alertsFragment = new DocumentFragment;

    alerts.forEach((alertData) => {
      if (!alertData.message) { return; }

      const alert = document.createElement(`li`);
      const level = alertData.level || `error`;
      const alert_icon = level === `info`
        ? this.getInfoIcon()
        : this.getErrorIcon();

      alert.classList.add(`${alert_basis}__alert`, `${alert_basis}__alert--${level}`);

      alert.innerHTML = `
        ${alert_icon}
        <span>${alertData.message}</span>
      `;
      alertsFragment.appendChild(alert);
    });

    alertsContainer.innerHTML = ``;
    alertsContainer.appendChild(alertsFragment);
    this.activateLiveRegion();
  }

  renderUnitPrice(cartItem, price, offer) {
    const unitPriceEl = cartItem.querySelector(`[data-cart-item-unit-price]`);
    const item = window.cart.items.filter((itemData) => {
      return itemData.key === cartItem.dataset.cartItemKey;
    })[0];
    
    if (this.getItemGiveaway(item)) { 
      unitPriceEl.innerHTML =  `<div>Free</div>`;

      return; 
    }
    
    if (!price) { return; }

    const finalPrice = unitPriceEl.getAttribute(`data-cart-item-unit-price`);
    const shopifyPrice = offer || price;
    const isDiscounted = Boolean(finalPrice !== `$${shopifyPrice}`);
    const useReducedPrice = Boolean(isDiscounted || offer);

    const html = useReducedPrice
      ? `
        <div class="cart-item__discounted-prices">
          <span class="visually-hidden">
            On sale price:
          </span>
          <strong class="cart-item__final-price">
            ${finalPrice}
          </strong>
          <span class="visually-hidden">
            Regular price:
          </span>
          <s class="cart-item__old-price">
            $${isDiscounted ? shopifyPrice : price}
          </s>
        </div>
        ${offer && !isDiscounted ? `<span class="cart-item__sale-label">ClubBev!</span>` : ``}`
      : `<div>
          $${price}
        </div>`;

    unitPriceEl.innerHTML = html;
  }

  getErrorsByType(response) {
    const functionalErrorCodes = [`variant_change`, `set_variant_quantity`];
    const itemErrors = response.items
      ? Object.entries(response.items).map(([item_key, item]) => {
        const variantId = Number(item_key.split(`:`)[0]);
        const populatedErrors = item.errors.map((error) => {
          return { ...error, item_variant: variantId };
        });
        
        return populatedErrors;
      })
      : [];

    const flatItemErrors = itemErrors.flat();
    const functionalErrors = [ ...response.cart_errors, ...flatItemErrors].filter(filterUniqueDeep).filter((error) => {
      return functionalErrorCodes.indexOf(error.error_code) > -1;
    });

    const visualCartErrors = response.cart_errors.filter(filterUniqueDeep).filter((error) => {
      return functionalErrorCodes.indexOf(error.error_code) === -1;
    });

    return { functionalErrors, visualCartErrors };
  }

  async handleFunctionalErrors(functionalErrors) {
    const updates = [];
    const cartData = await this.getCartJSON();

    for (const error of functionalErrors) {
      if (error.error_code === `set_variant_quantity`) {
        updates.push({ variantId: error.variant_id, quantity: error.quantity });
      } else if (error.error_code === `variant_change`) {
        const variantItems = cartData.items.filter((item) => {
          return item.variant_id === error.item_variant;
        });

        const quantity = variantItems.reduce((sum, item) => {
          return sum + item.quantity;
        }, 0);

        const newVariantUpdate = { variantId: error.variant_id, quantity };
        const oldVariantUpdate = { variantId: error.item_variant, quantity: 0 };

        updates.push(newVariantUpdate, oldVariantUpdate);
      }
    }

    try {
      const errorResponse = await this.updateCart(updates);

      return errorResponse;
    } catch (updateError) {
      console.log(`error processing functional errors`, updateError);
    }
  }

  async updateCart(updates = [], source = `cart`, open = false) {
    if (updates.length === 0) { return; }
    
    this.setCartLoading(true);
    const formData = new FormData();
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const cartData = await this.getCartJSON();

    updates.forEach((update) => {
      const { variantId, quantity } = update;
      const variantItems = cartData.items.filter((item) => {
        return item.variant_id === variantId;
      });

      if ((variantItems.length === 0) || (variantItems.length === 1)) {
        formData.append(`updates[${variantId}]`, quantity);
      } else {
        variantItems.forEach((item, index) => {
          if (index === 0) {
            formData.append(`updates[${item.key}]`, quantity);
          } else {
            formData.append(`updates[${item.key}]`, 0);
          }
        });
      }
    });

    if (this.cart) {
      formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    
    config.body = formData;

    try {
      const response = await fetch(`${routes.cart_update_url}`, config);
      const responseJSON = await response.json();
  
      if (!responseJSON.items) {
        this.setCartLoading(false);

        return responseJSON;
      }

      gopuffCustomAnalytics.publishCustomAnalyticsEventsByDiff(
        updates,
        responseJSON,
      );

      publish(PUB_SUB_EVENTS.cartUpdate, { source, cart: responseJSON });
      this.cart.renderContents(responseJSON, open);

      if (this.header) { this.header.reveal(); }
    } catch(err) {
      console.error(`error in updateCart`, err);
      this.setCartLoading(false);
    }
  }

  setIsInvalid(isInvalid = true, message = `Please correct the errors`) {
    this.isInvalid = isInvalid;

    if (this.isInvalid) {
      window.gopuffShopify.cart.checkout_disabled_message = message;
    }
  }

  setCartLoading(isLoading = true) {
    this.isCartLoading = isLoading;
    this.checkCheckoutDisabled();
  }

  setValidating(isValidating = true) {
    this.isValidating = isValidating;
    this.checkCheckoutDisabled();
  }

  getGiveawayCartItems(giveaway = {}) {
    const giveawayCartItems = window.cart.items.filter((item) => {
      return giveaway.skus.indexOf(item.sku) > -1;
    });  

    return giveawayCartItems || [];
  }
  
  validateGiveaway(items) {
    let isGiveawayValid = true;
    const giveaway = this.getCartGiveaway();

    if (giveaway) {
      const giveawayCartItems = this.getGiveawayCartItems(giveaway);
      let cartCount = 0;
      let variantCounts = {};

      giveawayCartItems.forEach((giveawayCartItem) => {
        variantCounts[giveawayCartItem.variant_id] = variantCounts[giveawayCartItem.variant_id] || 0;
        items[giveawayCartItem.key] = items[giveawayCartItem.key] || { errors: [] };
        
        const item = items[giveawayCartItem.key];
        const count = giveaway.limit_type === `cart`
          ? cartCount
          : variantCounts[giveawayCartItem.variant_id]; 

        const remaining = Math.max(giveaway.limit - count, 0);
        const allowedQuantity = (remaining >= giveawayCartItem.quantity) 
          ? giveawayCartItem.quantity
          : remaining;
        
        variantCounts[giveawayCartItem.variant_id] += allowedQuantity;

        if (giveaway.limit_type === `cart`) {
          cartCount += allowedQuantity;
        }
        
        if (allowedQuantity >= giveawayCartItem.quantity) { return; }
        
        item.errors.push({
          error_code: `set_variant_quantity`,
          variant_id: giveawayCartItem.variant_id,
          quantity: variantCounts[giveawayCartItem.variant_id],
        });
      });
    }

    return {
      isGiveawayValid,
      items,
    }
  }

  async validateCart(validationRequestData) {
    const responseRaw = await fetch(`${window.gopuffShopify.settings.api_base_url}/validate-cart`, { ...fetchConfig(), ...{ body: JSON.stringify(validationRequestData) } })
    const serverValidation = await responseRaw.json()

    if (!serverValidation.cart_errors) {
      throw new Error(`failed to get expected response from api`);
    }

    const cartThresholdReached = !document.querySelector('.cart-threshold');
    const { items, isGiveawayValid } = this.validateGiveaway(serverValidation.items);

    return {
      ...serverValidation,
      items,
      status: serverValidation.status && cartThresholdReached && isGiveawayValid,
    };
  }

  async checkProductAvailability(eventData, isSubmit = false) {    
    window.gopuffShopify.cart.checkout_disabled_message = ``;
    const deliveryLocation = JSON.parse(window.localStorage.getItem("delivery_location"));
    
    if (!deliveryLocation || !deliveryLocation.address) {
      this.setIsInvalid(true, `Please select a location before checkout`);
      this.checkCheckoutDisabled();

      return;
    }
    
    this.setValidating(true);
    const cart = await this.getCartJSON();

    if (cart.items.length === 0) { 
      this.setValidating(false);

      return; 
    }

    const { location_id, address } = deliveryLocation;
    const shopify_customer_id = window.gopuffShopify.customer 
      ? Number(window.gopuffShopify.customer.id)
      : null;

    const items = cart.items.map((item) => {
      const { id, properties, quantity, variant_id, key, sku, product_id } = item; 
      
      return {
        id,
        properties,
        quantity,
        variant_id,
        key,
        sku,
        product_id,
      };
    });

    const validationRequestData = {
      shopify_shop_domain: Shopify.shop,
      shopify_customer_id,
      location_id,
      address,
      cart: {
        items, 
      }
    };

    try {
      const response = await this.validateCart(validationRequestData);
      const { functionalErrors, visualCartErrors } = this.getErrorsByType(response);
      const shopifyErrors = [];
      const visualCartInfo = response.cart_info || [];
      const isValid = response.status;
      this.setIsInvalid(!isValid);

      this.checkCheckoutDisabled();

      if (functionalErrors.length > 0) {
        const errorResponse = await this.handleFunctionalErrors(functionalErrors);
        
        if (!errorResponse) { return; }

        this.setIsInvalid(true);
        shopifyErrors.push(errorResponse);
      }
  
      window.gopuffShopify.cart.changeMessage = ``;
      
      if (response.items) {
        for (const [cart_item_key, cart_item] of Object.entries(response.items)) {
          const cartItem = this.querySelector(`[data-cart-item-key="${cart_item_key}"]`);

          if (!cartItem) {
            // only expected on cart page until we update main-cart-items similarly to the cart drawer items
            continue;
          }

          const quantityChangeMessage = await this.limitQuantity(cartItem, cart_item.available_quantity);

          this.renderUnitPrice(cartItem, cart_item.price, cart_item.offer);
          this.renderAlerts(cartItem.querySelector(`[data-cart-item-alerts]`), cart_item.errors);
          window.gopuffShopify.cart.changeMessage += quantityChangeMessage;
        }
      }      

      const alerts = [...this.mapShopifyErrors(shopifyErrors), ...this.mapCartErrors(visualCartErrors), ...this.mapCartInfo(visualCartInfo)];
      this.renderAlerts(this.alertsStatusElement, alerts, `cart`);
      this.renderAlerts(this.cartChangesElement, [{ error_code: `change`, message: window.gopuffShopify.cart.changeMessage }], `cart`);

      if (isSubmit && isValid) {
        return true;  
      }

      this.setValidating(false);

      return false;
    } catch(e) {
      console.error(e);
      window.gopuffShopify.cart.changeMessage = `Please try again`;
      this.setValidating(false);
      gopuffCustomAnalytics.publishValidationEndpointError(validationRequestData);
    }
  }

  async getPromoStatuses() {
    const cart = await this.getCartJSON();
    const detailedItems = JSON.parse(document.querySelector(`[data-cart-items-json]`).innerHTML).items;

    cart.items.forEach((cartItem) => {
      const detailedItem = detailedItems.filter((item) => { return item.product_id === cartItem.product_id})[0];
      
      cartItem.tags = detailedItem 
        ? detailedItem.tags
        : ``;
    });

    const cartTags = cart.items.reduce((tagsArr, item) => {
      return [...tagsArr, ...item.tags.split(`, `)];
    }, []);

    const promos = window.gopuffShopify.productPromoMessages || [];
    const permanentDomain = Shopify.shop;

    const storePromoMessages = promos.filter((promo) => {
      return !promo.stores || (promo.stores.indexOf(permanentDomain) > -1);
    });

    const activePromos = storePromoMessages.filter((promo) => {
      const isPromoTagInCart = Boolean(!promo.tag || (cartTags.indexOf(promo.tag) > -1));

      return Boolean(isPromoTagInCart || promo.is_always_show_enabled);
    });

    return activePromos.map((promo) => {
      const matchingItems = promo.tag
        ? cart.items.filter((item) => {
          const tags = (item.tags || ``).split(`, `);

          return tags.indexOf(promo.tag) > -1;
        })
        : cart.items;

      const count = matchingItems.reduce((sum, item) => {
        const qualifier = promo.qualifier_type === `quantity`
          ? item.quantity
          : item.line_price;

        return sum + qualifier;
      }, 0);
      
      const num_remaining = promo.is_bundle_enabled
        ? promo.threshold - (count % promo.threshold)
        : Math.max(promo.threshold - count, 0);

      const num_pluralize = num_remaining === 1 
        ? ``
        :`s`;
       
      const discountCents = matchingItems.reduce((itemsSum, item) => {
        const matchingItemDiscounts = item.discounts.reduce((itemDiscountsSum, discount) => {
          const matchingDiscount = discount.title === promo.discount_message_status
            ? discount.amount
            : 0;

          return itemDiscountsSum + matchingDiscount;
        }, 0);

        return itemsSum + matchingItemDiscounts;
      }, 0);

      // 0.toLocaleString breaks - Number(0).toLocaleString works...
      const discount = Number(discountCents / 100).toLocaleString("en-US", {style:"currency", currency:"USD"});
      const num_remaining_str = promo.qualifier_type === `subtotal`
        ? Number(num_remaining / 100).toLocaleString("en-US", {style:"currency", currency:"USD"})
        : String(num_remaining);

      const statuses = [];

      if (discountCents > 0) {
        statuses.push(`completed`);
      }

      if ((statuses.indexOf(`completed`) === -1) || promo.is_bundle_enabled) {
        if (num_remaining < promo.threshold) {
          statuses.push(`in-progress`);
        } else {
          statuses.push(`initial`);
        }
      }

      return { 
        heading: promo.message_heading_status,
        initial_message: promo.initial_message_status.split(`{{ num }}`).join(num_remaining_str).split(`{{ num_pluralize }}`).join(num_pluralize),
        in_progress_message: promo.in_progress_message_status.split(`{{ num }}`).join(num_remaining_str).split(`{{ num_pluralize }}`).join(num_pluralize),
        completed_message: promo.completed_message_status.split(`{{ discount }}`).join(discount),
        theshold_percentage: Math.floor((promo.threshold - num_remaining) / promo.threshold * 100),
        button_url: promo.cta_url_status,
        button_cta: promo.cta_text_status,
        statuses,
      };
    });
  }

  async renderPromoStatuses() {
    const promoStatuses = await this.getPromoStatuses();

    document.querySelector(`promo-statuses`).setPromos(promoStatuses);
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ 
              note: event.target.value,
              sections: this.cart.getSectionsToRender().map((section) => section.section),
              sections_url: window.location.pathname
            });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};
